import { connect } from 'react-redux';

import { GET_ROOMS_OF_PLACE } from 'store/room/actionTypes';

import {
  ADD_PLACE_PRICE_TYPES,
  EDIT_PLACE_PRICE_TYPES,
  GET_PLACE_DETAIL,
  GET_PLACE_PRICE_TYPES,
} from 'store/place/actionTypes';

import { actionOpenModal } from 'store/global/modal/actions';

import EditPriceType from './EditPriceType';

const mapStateToProps = (state) => ({
  isLoadingGetRoomsOfPlace: state.Room.isLoadingGetRoomsOfPlace,
  isLoadingGetPlaceDetail: state.Place.isLoadingGetPlaceDetail,
  isLoadingAddPlacePriceTypes: state.Place.isLoadingAddPlacePriceTypes,
  isLoadingGetPlacePriceTypes: state.Place.isLoadingGetPlacePriceTypes,
  isLoadingEditPlacePriceTypes: state.Place.isLoadingEditPlacePriceTypes,

  roomsOfPlace: state.Room.roomsOfPlace,
  placePriceTypes: state.Place.placePriceTypes,
  placeDetail: state.Place.placeDetail,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetRoomsOfPlace: (payload) => dispatch({
    type: GET_ROOMS_OF_PLACE,
    payload,
  }),

  actionAddPlacePriceTypes: (payload) => dispatch({
    type: ADD_PLACE_PRICE_TYPES,
    payload,
  }),

  actionGetPlacePriceTypes: (payload) => dispatch({
    type: GET_PLACE_PRICE_TYPES,
    payload,
  }),

  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),

  actionEditPlacePriceTypes: (payload) => dispatch({
    type: EDIT_PLACE_PRICE_TYPES,
    payload,
  }),

  actionOpenModalCreateSuccess: (payload) => dispatch(actionOpenModal(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditPriceType);
